"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function PortfolioHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section id="portfolio-hero" ref={ref} className="relative h-screen w-full overflow-hidden rounded-b-[40px]">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1535610/img/portfolio_hero_building_night.png)]" />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-black/30" />

      {}
      <div className={`relative z-10 flex h-full flex-col items-center justify-center px-6 transition-all duration-[200ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
        {}
        <Breadcrumb className="mb-6">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/HomePage" className="text-white transition-all duration-150 hover:underline hover:underline-offset-4">
                  Home
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-white" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-white">
                Portfolio
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        {}
        <h1 className="font-display text-[clamp(3rem,8vw,5.625rem)] font-bold leading-tight text-white transition-transform duration-150 ease-out hover:translate-y-[-2px]">
          Portfolio
        </h1>
      </div>
    </section>;
}